<template>
  <div class="mobile-header">
    <div class="header-bar">
      <div class="left">
        <el-avatar class="avatar" :src="displayUser?.avatar"></el-avatar>
        <div class="info">
          <div class="name">{{ displayUser?.name }}</div>
          <div class="balance" v-if="showBalance">
            Balance <span>${{ displayUser?.balance }}</span>
          </div>
        </div>
      </div>

      <div class="menu-btn" @click="open">
        <img src="@/assets/menu.svg" alt="">
      </div>
    </div>
    <van-popup v-model="showPanel" position="bottom" >
      <div class="panel-btn secondary gap8"  v-if="showQuotationHallBtn" @click="goWithdraw('/quotationHall')">
        <img src="@/assets/quotation_icon.svg" alt="">
        Bidding Hall
      </div>
      <div class="panel-btn primary gap8" v-else @click="goWithdraw('/withdraw')">
        <img src="@/assets/wallet_white.svg" alt="">
        Withdraw
      </div>
      <div class="panel-btn secondary gap8" v-if="false" @click="handleSupport">
        <img src="@/assets/support_icon.svg" alt="">
        Support
      </div>
      <div class="panel-btn ghost gap8" @click="logoOut">
        <img src="@/assets/back_icon.svg" alt="">
        Logout
      </div>
      <div
        v-if="showEditBrandsBtn"
        class="panel-btn ghost"
        @click="goEditBrands"
      >
        Edit Brands
      </div>
      <p class="ft12 mb16 point rulesBox" v-if="showSupplierRulesEntry && $route.path != '/rules'" style="margin-top: 18px;" @click="goWithdraw('/rules')">Supplier Rules</p>
    </van-popup>
  </div>
</template>
<script>
import request from '@/utils/request'
import { logoOut, requiresRulesAgreement } from '@/utils/common'

let userRequestPromise = null; // ✅ 全局共享请求（关键）

export default {
  name: 'MobileHeader',

  props: {
    userInfo: {
      type: Object,
      default: () => null
    },
    showBalance: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      innerUserInfo: {},
      showPanel:false
    }
  },

  computed: {
    displayUser() {
      return this.userInfo || this.innerUserInfo || {};
    },
    showQuotationHallBtn() {
      return this.$route.path !== '/quotationHall'
    },
    showEditBrandsBtn() {
      return this.$route.path !== '/selectBrands'
    },
    showSupplierRulesEntry() {
      return requiresRulesAgreement()
    },
  },

  async mounted() {
    if (this.userInfo && this.userInfo.name) return;
    const local = localStorage.getItem('userInfo');
    if (local) {
      try {
        const parsed = JSON.parse(local);
        if (parsed && parsed.name) {
          this.innerUserInfo = parsed;
        }
      } catch (e) {
        localStorage.removeItem('userInfo');
        this.innerUserInfo = {};
      }
    }

    if (!userRequestPromise) {
      userRequestPromise = request.post('/api/get_user_info');
    }

    try {
      const res = await userRequestPromise;

      if (res.status) {
        this.innerUserInfo = res.data;

        localStorage.setItem('userInfo', JSON.stringify(res.data));

        // this.$emit('update:userInfo', res.data);
      }
    } catch (err) {
      console.error(err);
    }
  },
  methods:{
    open() {
      this.showPanel = true;
    },
    close() {
      this.showPanel = false;
    },
    goWithdraw(url){
      this.showPanel = false
      this.$router.push(url);
    },
    goEditBrands() {
      this.showPanel = false
      this.$router.push('/selectBrands')
    },
    logoOut(){
      logoOut()
    },
  }
}
</script>
<style scoped>
::v-deep .van-popup{
  border-radius: 8px 8px 0 0;
  padding: 12px 20px;
  box-sizing: border-box;
  .panel-btn {
    width: 100%;
    height: 48px;
    border-radius: 12px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
  }

  /* 样式 */
  .primary {
    background: var(--btn-primary-gradient);
    color: #fff;
  }

  .secondary {
    background: #eee7ff;
    color: #6c4df6;
  }

  .ghost {
    border: 1px solid #ddd;
    color: #999;
  }
}
.rulesBox{
  color: var(--btn-default-color);
}
.mobile-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #fff;
  margin-bottom: 12px;
}

.header-bar {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.name {
  font-weight: 600;
}

.balance {
  font-size: 12px;
  color: #999;
}

.balance span {
  color: #6c4df6;
  font-weight: bold;
}
</style>